<app-evida-error icon="evida_busy_error">
    <h2 class="header-medium" translate="shared.errormessages.status529.title"></h2>
    <p>
        <span translate="shared.errormessages.status529.description1"></span>
        <br />
        <strong translate="shared.errormessages.status529.description2"> </strong>
    </p>
</app-evida-error>
